import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Box } from '../Box';
import { LoadingStateCard } from './LoadingStateCard';

const Grid = styled(Box)<{ minCardWidth: string }>`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${props => props.minCardWidth}, 1fr)
  );
  grid-gap: 20px;
`;

type Props = PropsWithChildren<{
  minCardWidth?: string;
  isLoading?: boolean;
  loadingCardsCount?: number;
}>;

const CardsGrid = ({
  children,
  minCardWidth = '330px',
  isLoading,
  loadingCardsCount = 6,
}: Props) => {
  const loadingCards = Array.from(
    { length: loadingCardsCount },
    (_, cardId) => cardId
  );

  if (isLoading) {
    return (
      <Grid minCardWidth={minCardWidth}>
        {loadingCards.map(cardId => (
          <LoadingStateCard key={cardId} width="100%" />
        ))}
      </Grid>
    );
  }

  return <Grid minCardWidth={minCardWidth}>{children}</Grid>;
};

export { CardsGrid };
